module.exports = __webpack_public_path__ + "img/icon_menu01.f413a664.png";